/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentRadiationBeamParam from './treatment-radiation-beam-param';
import TreatmentRadiationBeamParamDetail from './treatment-radiation-beam-param-detail';
import TreatmentRadiationBeamParamUpdate from './treatment-radiation-beam-param-update';
import TreatmentRadiationBeamParamDeleteDialog from './treatment-radiation-beam-param-delete-dialog';

const TreatmentRadiationBeamParamRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentRadiationBeamParam />} />
    <Route path="new" element={<TreatmentRadiationBeamParamUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentRadiationBeamParamDetail />} />
      <Route path="edit" element={<TreatmentRadiationBeamParamUpdate />} />
      <Route path="delete" element={<TreatmentRadiationBeamParamDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentRadiationBeamParamRoutes;
